import React from "react";
import { STEP, stepEnabled } from "./wizardSteps";

const ORDER = [
  { key: STEP.SOURCE, no: 1, label: "원본데이터" },
  { key: STEP.CLASSIFY, no: 2, label: "세번분류" },
  { key: STEP.EXPORT, no: 3, label: "엑셀다운로드" },
];

/** 상단 스텝 탭 — 잠긴 스텝 외 자유 이동. 잡 상태와 스텝은 별개(wizardSteps 참고). */
export default function StepTabs({ step, jobStatus, hasSource, onChange }) {
  return (
    <div
      style={{
        display: "flex",
        gap: 24,
        borderBottom: "1px solid #e5e7eb",
        padding: "0 20px",
      }}
    >
      {ORDER.map((s) => {
        const enabled = stepEnabled(s.key, { status: jobStatus, hasSource });
        const active = step === s.key;
        return (
          <div
            key={s.key}
            onClick={() => enabled && onChange(s.key)}
            style={{
              padding: "10px 2px",
              fontSize: 13,
              cursor: enabled ? "pointer" : "default",
              color: active ? "#111827" : enabled ? "#6b7280" : "#d1d5db",
              fontWeight: active ? 700 : 400,
              borderBottom: active
                ? "2px solid #2563eb"
                : "2px solid transparent",
            }}
          >
            {s.no}. {s.label}
          </div>
        );
      })}
    </div>
  );
}
